import routes from 'config/config/routes';

const redirectRoute = (user, target, testCompletions, identityDocuments, anltcsEvents) => {
	const creationData = target?.targetProperties?.find((x) => x.name === 'creationData');
	const signData = target?.targetProperties?.find((x) => x.name === 'signData');
	const mainUserDni = identityDocuments.find((d) => d.main);
	const differentTestCompletions = [...new Set(testCompletions.map((tC) => tC.testId))];

	// console.log('⭕ user', user);
	// console.log('⭕ target', target);
	// console.log('⭕ testCompletions', testCompletions);
	// console.log('⭕ differentTestCompletions', differentTestCompletions);
	// console.log('⭕ identityDocuments', identityDocuments);
	// console.log('⭕ creationData', creationData);
	// console.log('⭕ signData', signData);
	// console.log('⭕ mainUserDni', mainUserDni);
	// console.log('⭕ anltcsEvents', anltcsEvents);

	const params = {
		routeParams: {
			targetId: target?.id,
		},
	};

	// USUARIO B2C NUEVO SIN DATOS
	// PASO 1.1 - simulationData
	if (!user?.metadata?.document) {
		return {
			step: 1,
			redirectRoute: routes.simulationData,
			params: {
				...params,
				queryParams: { internalStep: 1 },
			},
		};
	}
	// PASO 1.2 - simulationData
	if (!user?.metadata?.birthDate || !user?.metadata?.profession) {
		return {
			step: 1,
			redirectRoute: routes.simulationData,
			params: {
				...params,
				queryParams: { internalStep: 1 },
			},
		};
	}

	// PASO 1.3 - simulation
	if (!creationData?.value?.price) {
		return {
			step: 1,
			redirectRoute: routes.simulation,
			params: {
				...params,
				queryParams: { internalStep: 1 },
			},
		};
	}
	// PASO 1.4 - simulation
	if (!creationData?.value?.selectedPack) {
		return {
			step: 1,
			redirectRoute: routes.simulation,
			params: {
				...params,
				queryParams: { internalStep: 2 },
			},
		};
	}

	// PASO 2.1 - clientData
	if (!user?.name || !user?.surname || !user?.email || !user?.phoneNumber) {
		return {
			step: 2,
			redirectRoute: routes.clientData,
			params: {
				...params,
				queryParams: { internalStep: 1 },
			},
		};
	}
	// PASO 2.2 - clientData
	if (!user?.metadata?.professionalStatus) {
		return {
			step: 2,
			redirectRoute: routes.clientData,
			params: {
				...params,
				queryParams: { internalStep: 2 },
			},
		};
	}
	// PASO 2.3 - clientData
	if (!user?.metadata?.healthQuestions) {
		return {
			step: 2,
			redirectRoute: routes.clientData,
			params: {
				...params,
				queryParams: { internalStep: 3 },
			},
		};
	}
	// PASO 2.4 - clientData
	if (!creationData?.value?.details?.beneficiaryType) {
		return {
			step: 2,
			redirectRoute: routes.clientData,
			params: {
				...params,
				queryParams: { internalStep: 4 },
			},
		};
	}

	// PASO 3 - identityBiometricUpsert
	if (!mainUserDni || !mainUserDni?.number || mainUserDni?.verificationStatus !== 'VALID') {
		return {
			step: 3,
			redirectRoute: routes.identityBiometricUpsert,
			params,
		};
	}

	// PASO 4 - bankAccount
	if (!creationData?.value?.chargeAccount) {
		return {
			step: 4,
			redirectRoute: routes.bankAccount,
			params,
		};
	}

	// PASO 5 - activateProduct
	if (target?.status !== 'ACTIVATING') {
		return {
			step: 5,
			redirectRoute: routes.activateProduct,
			params,
		};
	}

	// PASO 6.1 - signatureSteps
	if (target?.status === 'ACTIVATING') {
		return {
			step: 6,
			redirectRoute: routes.signatureSteps,
			params: {
				routeParams: { ...params.routeParams, envelopeId: signData?.value?.envelopeId },
				queryParams: { internalStep: 1 },
			},
		};
	}

	// PASO 6.2 - signatureContract
	if (target?.status === 'ACTIVATING') {
		return {
			step: 6,
			redirectRoute: routes.signatureContract,
			params: {
				routeParams: { ...params.routeParams, envelopeId: signData?.value?.envelopeId },
				queryParams: { internalStep: 2 },
			},
		};
	}

	// PASO 7 - error
	if (target?.status === 'ACTIVATION_FAILED') {
		return {
			step: 7,
			redirectRoute: routes.activateProduct,
			params,
		};
	}

	// PASO 7 - productCreationFinished
	if (target?.status === 'ACTIVE') {
		return {
			step: 7,
			redirectRoute: routes.productCreationFinished,
			params: {
				routeParams: { ...params.routeParams, envelopeId: signData?.value?.envelopeId },
			},
		};
	}

	return {
		step: 0,
		redirectRoute: routes.loginClient,
		params,
	};
};

export default redirectRoute;
